import { combineReducers } from 'redux';
import { get } from 'lodash';

import {
  GET_SHOPIFY_MATCHES,
  SAVE_SHOPIFY_SETTINGS,
  SET_SHOPIFY_STATE,
  SET_SHOPIFY_MATCHES,
  RESET_SHOPIFY_MATCHES,
  GET_SHOPIFY_REMOTE_LOCATIONS,
  GET_SHOPIFY_REMOTE_LOCATIONS_ERROR,
  SET_SHOPIFY_REMOTE_LOCATIONS,
  SET_SHOPIFY_SELECTED_ITEMS,
  SET_SHOPIFY_ALL_SELECTED,
  RESET_SHOPIFY_SELECTED_ITEMS,
  SHOPIFY_NOT_SET,
  GET_SHOPIFY_SETTINGS,
  GET_SHOPIFY_SETTINGS_ERROR,
} from '../constants';

const initialSettingsState = {
  loading: false,
  settings: {},
};

const shopifySettingsReducer = (state = initialSettingsState, { type, payload }) => {
  switch (type) {
    case GET_SHOPIFY_SETTINGS:
      return {
        ...state,
        loading: true,
      };
    case GET_SHOPIFY_SETTINGS_ERROR:
      return initialSettingsState;
    case SAVE_SHOPIFY_SETTINGS:
      return {
        loading: false,
        settings: payload,
      };
    default:
      return state;
  }
};

const shopifyStateReducer = (state = SHOPIFY_NOT_SET, { type, payload }) => {
  switch (type) {
    case SET_SHOPIFY_STATE:
      return payload;
    default:
      return state;
  }
};

const initialMatchesState = {
  loading: false,
  list: [],
  pagination: {
    count: 0,
    page: 1,
    perPage: 1000,
    totalPages: 0,
  },
  selectedItems: [],
  allSelected: false,
};

const shopifyMatchesReducer = (state = initialMatchesState, { type, payload }) => {
  switch (type) {
    case GET_SHOPIFY_MATCHES:
      return {
        ...state,
        loading: true,
      };
    case SET_SHOPIFY_MATCHES: {
      const list = get(payload, 'list', []);

      return {
        ...state,
        list,
        pagination: payload.pagination,
        loading: false,
      };
    }
    case RESET_SHOPIFY_SELECTED_ITEMS:
      return {
        ...state,
        selectedItems: [],
      };
    case SET_SHOPIFY_SELECTED_ITEMS:
      return {
        ...state,
        selectedItems: payload,
      };
    case SET_SHOPIFY_ALL_SELECTED: {
      return {
        ...state,
        ...payload,
      };
    }
    case RESET_SHOPIFY_MATCHES:
      return {
        ...initialMatchesState,
      };
    default:
      return state;
  }
};

const shopifyLocationsInitialState = {
  shopifyLocations: [],
  locationsToOptions: [],
  loading: false,
};

const shopifyLocationsReducer = (state = shopifyLocationsInitialState, { type, payload }) => {
  switch (type) {
    case GET_SHOPIFY_REMOTE_LOCATIONS:
      return {
        ...state,
        loading: true,
      };
    case SET_SHOPIFY_REMOTE_LOCATIONS:
      return {
        ...state,
        ...payload,
        loading: false,
      };
    case GET_SHOPIFY_REMOTE_LOCATIONS_ERROR:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

const reducer = combineReducers({
  shopifySettings: shopifySettingsReducer,
  shopifyConnectionState: shopifyStateReducer,
  shopifyMatches: shopifyMatchesReducer,
  shopifyLocations: shopifyLocationsReducer,
});

export default reducer;
